export default "/images/vendor/flag-icon-css/flags/1x1/ph.svg?801b5ef1f9bb57d51f68022eb7a8107a";